import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ISettings, IStoriesSettingsMessages } from '../../../../types';
import { styles } from './Analytics.styles';

export type IAnalyticsProps = {
  settings: ISettings;
  messages: IStoriesSettingsMessages;
  updateSettingsProps(newSettingsProps: Partial<ISettings>): void;
};

export const Analytics = ({ settings, messages, updateSettingsProps }: IAnalyticsProps) => {
  return (
    <Box>
      <Typography variant="h5" sx={styles.heading}>{messages.analytics}</Typography>
      <Typography variant="body2" sx={styles.description}>{messages.analyticsBodyText}</Typography>
      <TextField
        fullWidth
        size="small"
        label={messages.analyticsLabel}
        value={settings.advanced.google_analytics_id}
        onChange={(e) => updateSettingsProps({ advanced: { ...settings.advanced, google_analytics_id: e.target.value } })}
        placeholder={messages.analyticsPlaceholder}
        inputProps={{ 'data-test': 'google-analytics-tracking-id', className: 'no-format' }}
      />
    </Box>
  );
};
